export const collumns = [
  { title: 'Full Name', width: 250 },
  { title: 'Username', width: '20%' },
  { title: 'Role', width: '15%' },
  { title: 'Type', width: '200px' },
  { title: '', width: '10%' },
]

export const data = [
  {
    id: 1,
    chapter: 'Cras et neque ut ex placerat dapibus non eget est.',
    question: 100,
  },
  { id: 2, chapter: 'Definition and issues ', question: 100 },
  {
    id: 3,
    chapter:
      'Morbi sit amet ante sit amet felis condimentum imperdiet ut a nunc.',
    question: 100,
  },
  {
    id: 4,
    chapter:
      'Suspendisse laoreet libero in dolor sodales, eu imperdiet nulla condimentum.',
    question: 100,
  },
]

// export const UserTabs = { all: 'all', tutor: 'tutor', student: 'student' }
export const UserTabs = [
  { value: 'all', label: 'All' },
  { value: 'unassigned', label: 'Unassigned' },
]

export const UserFilterTypes = [
  { value: 'all', label: 'All' },
  { value: 'manual', label: 'Registered by User' },
  { value: 'moodle', label: 'Synced from KCB LMS' },
]

export const UserStatus = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Deleted' },
]

export const UserRoles = [
  { value: 'all', label: 'All' },
  { value: 'tutor', label: 'Tutors' },
  { value: 'student', label: 'Students' },
]

export const UserType = {
  MANUAL: 'Registered by User',
  MOODLE: 'Synced from KCB LMS',
}
